import { api } from "~/providers/api";
import {
  OrganizationNotifyListResponse,
  OrganizationProvidersResponse,
  UpdateOrganizationNotifyListRequest,
} from "~/providers/types/teamMembers";

export const listOrganizationProviders = async (organizationId: string) => {
  const response = await api.get<OrganizationProvidersResponse[]>(
    `/v1/organizations/${organizationId}/team-members`,
  );

  return response.data;
};

export const listOrganizationNotifyList = async (organizationId: string) => {
  const response = await api.get<OrganizationNotifyListResponse>(
    `/v1/organizations/${organizationId}/notification-list`,
  );

  return response.data;
};

export const updateOrganizationNotifyList = async ({
  organizationId,
  ...payload
}: UpdateOrganizationNotifyListRequest) => {
  const response = await api.put<OrganizationNotifyListResponse>(
    `/v1/organizations/${organizationId}/notification-list`,
    payload,
  );

  return response.data;
};
